import { render, staticRenderFns } from "./SectorInfo.vue?vue&type=template&id=4e9674b4&scoped=true&"
import script from "./SectorInfo.vue?vue&type=script&lang=js&"
export * from "./SectorInfo.vue?vue&type=script&lang=js&"
import style0 from "@/styles/SectorInfo.scss?vue&type=style&index=0&lang=scss&"
import style1 from "./SectorInfo.vue?vue&type=style&index=1&id=4e9674b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9674b4",
  null
  
)

export default component.exports